import gpay from "../../../../assets/images/gpay.png";
import phonepe from "../../../../assets/images/phonepe.png";
import paytm from "../../../../assets/images/paytm.png";
import "./upiApps.css"

const UpiApps = ({paymentButtonFunc , getUpiIntent}) => {

    const AppIcon = ({iconImg , name ,deepLinkName}) => {
        return (
            <div 
               className="app-info"
               onClick={() => getUpiIntent(deepLinkName) }
            >
              <div  className="app-icon">
                  <img
                      src={iconImg}
                      alt=""
                      width={"50px"}
                      height={"50px"}
                    
                  />
              </div>
                 <span className="app-info">{name}</span>
            </div>
        )
    }

  return (
    <div className="payment-container">
        <h2>Payment Methods</h2>
        <p>Quick Pay with UPI Apps</p>
         <div className="app-container">
            <AppIcon iconImg={gpay} name="Google Pay" deepLinkName="Gpay"  />
            <AppIcon iconImg={phonepe} name="Phone pe" deepLinkName="Phonepe" />
            <AppIcon iconImg={paytm} name="Paytm" deepLinkName="paytm" />
         </div>
         <div className="divider-container">
            <div className="divider" ></div>
            <p>or</p>
            <div className="divider" ></div>
         </div> 
         <button className="more-payments" onClick={() => paymentButtonFunc()} >View Other Payment Options</button>
    </div>
  )
}

export default UpiApps